import React, { memo } from "react";
import { EventCellDivider } from "./style";

const KTEventCellDivider = memo(() => {
  return <EventCellDivider />;
});

export default KTEventCellDivider;
